import React,{useState} from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../components/MCSPagedTable';
import MCSLoading from '../../../components/MCSLoading';
import Icon from '@visa/vds/icon';

function AccessRequestOrganizationTable(props){
    let colHeaders = [  
        {displayName:"Organization", name:"orgName",orderable: false, defaultOrdered : false},
        {displayName:"BID", name:"bid",orderable: false},
        {displayName:"Region", name:"regionName",orderable: false},
        {displayName:"Country",name:"countryName",orderable: false}, 
        {displayName:"Company Rep",name:"primaryVisaContact",orderable:false},
        {displayName:"",name:"actions",orderable:false}
    ];

    const [selectedPage,setSelectedPage] = useState(1)

    const fetchDataOnPageChange = (page) =>{
        setSelectedPage(page);
        props.fetch(page);
    }

    if(!props.fetched){
        return(<MCSLoading/>)
    }
    else{
        return (
        <>
        <MCSPagedTable size={"compact"}
            colHeaders={colHeaders} 
            useSearchBar={false}
            usePagination={true}
            selectedPage={selectedPage} setSelectedPage={fetchDataOnPageChange} totalPages={props.totalPages}
            tableData={
                props.data && props.data.items.map((row,key)=>(
                <Tr key={key}>
                    <Td>{row.orgName}</Td>
                    <Td>{row.bid}</Td>
                    <Td>{row.regionName}</Td>
                    <Td>{row.countryName}</Td>
                    <Td>{row.primaryVisaContact}</Td>
                    <Td><Icon onClick={()=>props.setSelectedOrganization(row)} className="vss-clickable-icon" name="settings" resolution="low" /></Td>
                </Tr>
                ))
            }/>
        </>
        );
    }
  }


export default AccessRequestOrganizationTable;
